module.exports = __webpack_public_path__ + "c08cc81658d673c45c1240d5fd31569f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/stars.png
// module id = 3376
// module chunks = 0